import { render, staticRenderFns } from "./lopsandrlops.vue?vue&type=template&id=19c27ac2&scoped=true"
import script from "./lopsandrlops.vue?vue&type=script&lang=js"
export * from "./lopsandrlops.vue?vue&type=script&lang=js"
import style0 from "./lopsandrlops.vue?vue&type=style&index=0&id=19c27ac2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c27ac2",
  null
  
)

export default component.exports